import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router/index';
import stores from '@/store/index';
import vant from '@/config/vant';
import api from '@/config/api';
import filters from '@/config/filter';
import babelPolyfill from 'babel-polyfill';
import {Get, Post, Put} from '@/config/axios';
import tools from '@/config/tools';
import VueClipboard from 'vue-clipboard2';
import VConsole from 'vconsole';

let debugList = ['ta.jumstc.com:10507', 'ta.jumstc.com:13002', 'ta.jumstc.com:10504'];
console.log(process.env.API_ROOT_MAIN);
if (debugList.some(item => process.env.API_ROOT_MAIN.indexOf(item) !== -1)) {
    console.log('debug');
    VConsole.default = VConsole;
    window.VConsole = new VConsole();
}

// API
Vue.prototype.$api = api;
Vue.prototype.$post = Post;
Vue.prototype.$get = Get;
Vue.prototype.$put = Put;
Vue.use(VueClipboard);

// Filter
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key]);
});
// 全局函数
Vue.prototype.$tools = tools;

/* eslint-disable no-new */
new Vue({
    router,
    vant,
    store: stores,
    babelPolyfill,
    el: '#fyapp',
    render: (h) => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js